import { render, staticRenderFns } from "./ContestModal.vue?vue&type=template&id=45e088f2&scoped=true&"
import script from "./ContestModal.vue?vue&type=script&lang=ts&"
export * from "./ContestModal.vue?vue&type=script&lang=ts&"
import style0 from "./ContestModal.vue?vue&type=style&index=0&id=45e088f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e088f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
